import { render } from "./MasterLoader.vue?vue&type=template&id=1c5b76a6"
import script from "./MasterLoader.vue?vue&type=script&lang=js"
export * from "./MasterLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__